import React, { Component } from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import "./scss/style.scss";

const loading = (
  <div className="pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse"></div>
  </div>
)

const TheLayout = React.lazy(() => import("./containers/TheLayout"));
const Login = React.lazy(() => import("./views/pages/login"));
const Page404 = React.lazy(() => import("./views/pages/page404/Page404"));
const Page500 = React.lazy(() => import("./views/pages/page500/Page500"));
const CriarConta = React.lazy(() => import("./views/pages/criar-conta"));
const ConfirmarEmail = React.lazy(() => import("./views/pages/confirmar-email"));
const RedefinirSenha = React.lazy(() => import("./views/pages/redefinir-senha"));


class App extends Component {
  render() {
    return (
      <Router>
        <React.Suspense fallback={loading}>
          <Switch>
            <Route exact path="/login" name="Login Page" render={props => <Login {...props} />} />
            <Route exact path="/404" name="Page 404" render={props => <Page404 {...props} />} />
            <Route exact path="/500" name="Page 500" render={props => <Page500 {...props} />} />
            <Route exact path="/criar-conta" name="Criar Conta" render={() => <CriarConta />} />
            <Route exact path="/confirmar-email" name="Confirmar E-mail" render={() => <ConfirmarEmail />} />
            <Route exact path="/redefinir-senha" name="Redefinir Senha" render={() => <RedefinirSenha />} />
            <Route path="/" name="Home" render={props => <TheLayout {...props} />} />
          </Switch>
        </React.Suspense>
      </Router>
    );
  }
}

export default App;
